<script>
import { Bar } from 'vue-chartjs'

export default {
  name: 'TrainedPlayerChart',
  extends: Bar,
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    data () {
      return this.value.map(item => item.qty)
    },
    options () {
      return {
        legend: { display: false },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            title: tooltipItem => `${tooltipItem[0].label} ${this.value[tooltipItem[0].index].year}`,
          },
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 1,
              suggestedMax: Math.ceil(Math.max(...this.data) * 1.1),
            },
          }],
        },
      }
    },
    chartdata () {
      return {
        labels: this.value.map(item => this.$t(`date.monthList[${item.month}]`)),
        datasets: [{
          backgroundColor: 'rgba(138, 62, 112, 0.8)',
          borderColor: 'rgb(138, 62, 112)',
          pointBackgroundColor: 'rgb(138, 62, 112)',
          data: this.data,
        }],
      }
    },
  },
  watch: {
    chartdata () {
      this.renderChart(this.chartdata, this.options)
    },
  },
  mounted () {
    this.renderChart(this.chartdata, this.options)
  },
}
</script>
